import React, {
 useState, useEffect, useContext
} from 'react';
import {
    Tabs, TabsContent, TabsList, TabsTrigger
} from 'shared/components/ui/tabs';
import {
    Table2, Wand2, Database, ArrowLeft
} from 'lucide-react';
import DataBuilderPage from './DataBuilder';
import AppInfo from './AppInfo';
import {
 Breadcrumb
} from 'shared/components/ui/breadcrumb';
import {
 PageBuilderTab
} from './3dBuilder/PageBuilderTab';
import {
 applicationService
} from 'shared/api/services/BEXO';
import {
 useNavigate, useParams
} from 'react-router-dom';
import {
 Button
} from 'shared/components/ui/button';

import {
 Application
} from './types/builderApp.types';
import {
    Context
} from 'shared/context/GlobalState';

export function ManageApp() {
    const {
 appId, oragID
} = useParams<{ appId: string, oragID: string }>();
    const [application, setApplication] = useState<Application | null>(null);
    const [applicationLoading, setApplicationLoading] = useState<boolean>(true);

    const navigate = useNavigate();

    const tabs = [
        {
 value: 'manage-app'
},
        {
 value: 'data-builder'
},
        {
 value: 'story-builder'
},
    ];
     const {
         addNewNotifcation
    } = useContext(Context);

    const handleTabChange = (page: string) => {
        navigate(page, {
            relative: 'path',
        });
    };
useEffect(() => {
  const fetchApplication = async () => {
    try {
      const data = await applicationService.getApplication(oragID, appId);

      // Type guard to ensure 'data' is of type 'ApplicationDetails'
      if ('active' in data) {
        setApplication(data as Application); // Now it's safe to set Application type
      } else {
        console.error('Error response received:', data);
         addNewNotifcation('Failed to fetch application data', 'danger');
      }
    } catch (error) {
      console.error('Failed to fetch application:', error);
    addNewNotifcation('Something went wrong while fetching application', 'danger');
    } finally {
      setApplicationLoading(false);
    }
  };

  fetchApplication();
}, [oragID, appId]);

    return (
        <div className="flex flex-col overflow-y-scroll w-full ">
            <Breadcrumb />
            <div className="border-b bg-background px-8 py-6">
                <div className="mx-auto">
                    <Button
                        className="w-fit h-fit p-2 flex justify-center"
                        onClick={() => navigate('..', {
 relative: 'path'
})}
                        variant="ghost"
                    >
                        <ArrowLeft className="w-5 h-5" />
                    </Button>

                    <h1 className="text-3xl font-bold tracking-tight my-2">
                        {application?.name || 'Application Details'}
                    </h1>
                    <p className="text-muted-foreground">
                        Manage Application Status, Data builder, and Story builder
                    </p>
                </div>
            </div>

            <div className="px-8 py-6 w-full">
                <Tabs defaultValue="manage-app" onValueChange={handleTabChange} className="w-full">
                    <TabsList className="w-full flex justify-around rounded-none border-b bg-transparent p-0 h-auto">
                        <TabsTrigger
                            value={tabs[0].value}
                            className="flex flex-1 items-center justify-center gap-2 rounded-none border-b-2 border-transparent px-4 py-3 font-medium
                            hover:bg-muted/80 hover:text-primary transition-colors
                            data-[state=active]:border-primary data-[state=active]:bg-primary/5 data-[state=active]:text-primary"
                            onClick = {() => handleTabChange('manage-app')}
                        >
                            <Table2 className="h-4 w-4" />
                            Application Info
                        </TabsTrigger>
                        <TabsTrigger
                            value={tabs[1].value}
                            className="flex flex-1 items-center justify-center gap-2 rounded-none border-b-2 border-transparent px-4 py-3 font-medium
                            hover:bg-muted/80 hover:text-primary transition-colors
                            data-[state=active]:border-primary data-[state=active]:bg-primary/5 data-[state=active]:text-primary"
                            onClick = {() => handleTabChange('data-builder')}
                        >
                            <Database className="h-4 w-4" />
                            Data builder
                        </TabsTrigger>
                        <TabsTrigger
                            value={tabs[2].value}
                            className="flex flex-1 items-center justify-center gap-2 rounded-none border-b-2 border-transparent px-4 py-3 font-medium
                            hover:bg-muted/80 hover:text-primary transition-colors
                            data-[state=active]:border-primary data-[state=active]:bg-primary/5 data-[state=active]:text-primary"
                            onClick = {() => handleTabChange('story-builder')}
                        >
                            <Wand2 className="h-4 w-4" />
                            Story Builder
                        </TabsTrigger>
                    </TabsList>

                    <div className="mt-6">
                        <TabsContent value="manage-app" className="m-0 w-full">
                            <div className="w-full">
                                <AppInfo application={application} setApplication={setApplication} applicationLoading={applicationLoading} />
                            </div>
                        </TabsContent>

                        <TabsContent value="data-builder" className="m-0 w-full">
                            <div className="w-full">
                                <DataBuilderPage />
                            </div>
                        </TabsContent>

                        <TabsContent value="story-builder" className="m-0 w-full">
                            <div className="w-full">
                                <PageBuilderTab />
                            </div>
                        </TabsContent>
                    </div>
                </Tabs>
            </div>
        </div>
    );
}
